import type { FormControlProps } from '../FormControl';
import { FormControl } from '../FormControl';

import type { InputProps } from './Input';
import { Input } from './Input';

export type InputTextFieldProps = FormControlProps & InputProps;

export function InputTextField({
	label,
	labelStyle,
	helperText,
	helperStyle,
	error,
	outerStyle,
	infoText,
	...other
}: InputTextFieldProps) {
	return (
		<FormControl
			label={label}
			labelStyle={labelStyle}
			helperText={helperText}
			helperStyle={helperStyle}
			error={error}
			outerStyle={outerStyle}
			infoText={infoText}
		>
			<Input error={error} {...other} />
		</FormControl>
	);
}
